import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { Link, Tooltip } from '@material-ui/core';
import HelpIcon from '@material-ui/icons/HelpOutline';
import ClipboardCopy from '../../ClipboardCopy';
import { VNC_HELP_URL } from '../../../constants/api-constants';

const styles = () => ({
    paper: {
        width: '600px'
    },
    colorRed: {
        color: 'red'
    }
});

const VNCModal = props => {
    const {
        fullScreen,
        close,
        vncConfig: {
            tunnel: {
                deviceName,
                engine: { address },
                clientPort
            }
        }
    } = props;
    const buildVNCFile = `Host=${address}:${clientPort}
Quality=Low
RelativePtr=0`;
    const href = `data:application/vnc;charset=utf-8,${encodeURIComponent(
        buildVNCFile
    )}`;
    const title = (
        <div>
            Contains settings for a Virtual Network Computing (VNC) connection
            from one computer to another.
            <br />
            <strong style={{ fontSize: 12 }}>
                Programs that open VNC files
            </strong>
            <br />
            <strong style={{ fontSize: 11 }}> Windows: </strong> UltraVNC,
            TightVNC, RealVNC VNC Personal/Enterprise Edition
            <br />
            <strong style={{ fontSize: 11 }}> Mac OS: </strong>RealVNC VNC
            Enterprise Edition
            <br />
            <strong style={{ fontSize: 11 }}> Linux: </strong>RealVNC VNC
            Enterprise Edition
        </div>
    );
    return (
        <Dialog fullScreen={fullScreen} open onClose={close}>
            <DialogContent>
                <Typography>
                    Your VNC tunnel to device will be available in few seconds.
                </Typography>
                <br />
                <Typography>
                    <div style={{ display: 'flex', fontWeight: 'bold' }}>
                        Virtual Network Computing Connection file
                        <Tooltip title={title} placement="bottom">
                            <HelpIcon
                                style={{ marginLeft: 5 }}
                                fontSize="small"
                                color="primary"
                            />
                        </Tooltip>
                    </div>
                </Typography>
                <Typography>
                    <Link
                        target="_blank"
                        download={`${deviceName}.vnc`}
                        rel="noopener noreferrer"
                        href={href}
                    >
                        Download settings file (.VNC )
                    </Link>
                </Typography>
                <br />
                <Typography style={{ fontWeight: 'bold' }}>
                    For manual configuration use following:
                </Typography>
                <Typography>
                    Address: <ClipboardCopy text={address} value={address} />
                </Typography>
                <Typography>
                    Port: <ClipboardCopy text={clientPort} value={clientPort} />
                </Typography>
                <br />
                <Link
                    style={{ marginTop: 15 }}
                    rel="noopener noreferrer"
                    target="_blank"
                    href={VNC_HELP_URL}
                >
                    Click here for additional information about VNC
                    configuration.
                </Link>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="primary" onClick={close}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};
VNCModal.propTypes = {
    fullScreen: PropTypes.bool,
    close: PropTypes.func,
    vncConfig: PropTypes.object.isRequired
};

export default withMobileDialog()(withStyles(styles)(VNCModal));
